var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[ 'dropdown-item', (_vm.active && 'is-active') ]},[_vm._t("default"),_c('span',{staticClass:"dropdown-item-control flex is-row"},[_vm._t("control")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }